/* eslint-disable class-methods-use-this */
import {
  CountryData,
  defaultCountries,
  parseCountry,
} from 'react-international-phone';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { Countries } from '@constants/enums';

const phoneUtil = PhoneNumberUtil.getInstance();

export default class PhoneInputService {
  getBaseCountry = (
    country?: keyof typeof Countries | 'ALL'
  ): CountryData[] => {
    if (country === Countries.USA) {
      return this.buildIsoCountriesArray(['us']);
    }
    if (country === Countries.COL) {
      return this.buildIsoCountriesArray(['co']);
    }
    if (country === Countries.MX) {
      return this.buildIsoCountriesArray(['mx']);
    }
    if (country === 'ALL') {
      return defaultCountries;
    }
    return this.buildIsoCountriesArray(['us', 'co', 'mx']);
  };

  buildIsoCountriesArray = (countries: string[]): CountryData[] =>
    defaultCountries.filter((country) => {
      const { iso2 } = parseCountry(country);
      return countries.includes(iso2);
    });

  validatePhoneNumber = (phone: string) => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch {
      return false;
    }
  };
}
